import { clone } from 'ramda';

import { IJsonQuery } from './types/jsonQuery';
import { setTerm, resetTerms } from './helpers';

export function setApartments(jsonQuery: IJsonQuery) {
  return (apartments: boolean | null): IJsonQuery => {
    let nextJsonQuery = clone(jsonQuery);

    nextJsonQuery = resetTerms(['only_flat', 'apartment'])(nextJsonQuery);

    if (apartments) {
      nextJsonQuery = setTerm('apartment')(nextJsonQuery)(true);
    } else if (apartments !== null) {
      nextJsonQuery = setTerm('only_flat')(nextJsonQuery)(true);
    }

    return nextJsonQuery;
  };
}
